import EmptyState from 'components/EmptyState';
import { ENTITY_TYPE_LABEL, GLOBAL_SEARCH_ENTITY_LABEL_ID } from 'components/global-search/entityDisplay';
import { History } from 'components/icons';
import LineClamp from 'components/misc/LineClamp';
import { formatRelativeTimeFromNow } from 'pages/ai-chat/utils/relativeTime';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';
import { pathForResult } from 'utils/globalSearchRoutes';
import { readRecentlyViewed } from 'utils/recentlyViewed';
import HomeSection from './HomeSection';

const SHOWN_RECENTS = 4;

/** The records this browser opened last, read once on mount, or what stands in for them while there are none. */
export default function ContinueSection() {
    const intl = useIntl();
    const [recents] = useState(() => readRecentlyViewed().slice(0, SHOWN_RECENTS));

    return (
        <HomeSection title={t('home.continue')} className="gap-3.5 pb-[18px]">
            {recents.length === 0 ? (
                <EmptyState
                    size="panel"
                    icon={History}
                    titleId="home.continue-empty.title"
                    bodyId="home.continue-empty.body"
                    className="min-h-0 flex-1 py-4"
                />
            ) : (
                <div className="grid min-h-0 flex-1 grid-cols-[repeat(auto-fill,minmax(9rem,1fr))] gap-3 overflow-y-auto">
                    {recents.map((record) => {
                        // A family the tile does not name in the singular keeps its search label, in grey.
                        const type = ENTITY_TYPE_LABEL[record.entityType];
                        return (
                            <Link
                                key={`${record.entityType}-${record.id}`}
                                to={pathForResult(record.entityType, record.id)}
                                className="border-neutral-tint bg-surface-tile text-foreground hover:border-border-control flex min-w-0 flex-col gap-1.5 rounded-md border p-3 no-underline"
                            >
                                <span
                                    className={cn('text-label uppercase', type?.className ?? 'text-muted-foreground')}
                                >
                                    {t(type?.labelId ?? GLOBAL_SEARCH_ENTITY_LABEL_ID[record.entityType])}
                                </span>
                                <LineClamp maxLineCount={2} className="leading-[1.35] font-medium">
                                    {record.displayName}
                                </LineClamp>
                                <span className="text-muted-foreground text-caption mt-auto">
                                    {formatRelativeTimeFromNow(intl, record.viewedAt)}
                                </span>
                            </Link>
                        );
                    })}
                </div>
            )}
        </HomeSection>
    );
}
